import React from "react";
import PropTypes from "prop-types";
import { useSDCValidation } from "../../utils/useSDCValidation";

const SerialNumberInput = ({
  serialNumberSubmit,
  serialNumberWarning,
  serialNumberErrors,
  pioneerBrand,
  needsValidation,
  localized,
  setSerialNumberSubmit,
  handleEnter,
  validateSerialNumber,
  itemNumberSubmit,
  illegitimateSerialNumber,
  isMissingSerial,
  isSDCItem,
}) => {
  const { invalidSDCFormat } = useSDCValidation(serialNumberSubmit, isSDCItem);

  const getInputClass = () => {
    const shouldValidateInput = !(
      pioneerBrand?.shown && !pioneerBrand.required
    );

    if (!shouldValidateInput) {
      return "";
    }

    if (isSDCItem && invalidSDCFormat) {
      return "is-invalid";
    }

    if (needsValidation) {
      const hasOtherError =
        (illegitimateSerialNumber ||
          serialNumberWarning ||
          serialNumberErrors ||
          serialNumberSubmit.length < 1) &&
        isMissingSerial === false;

      return hasOtherError ? "is-invalid" : "is-valid";
    }

    return "";
  };

  const getErrorMessage = () => {
    const errorConditions = [
      [serialNumberWarning, localized.DuplicateSerialSubmitWarning],
      [
        serialNumberSubmit.length === 0,
        localized.EmptySerialSubmitWarning || "",
      ],
      [serialNumberErrors, localized.InvalidSerialSubmitWarning || ""],
      [illegitimateSerialNumber, localized.IllegitimateSerialNumber || ""],
      [invalidSDCFormat, ""],
    ];

    const error = errorConditions.find(([condition]) => condition);

    return error ? error[1] : localized.AlphanumericSubmitWarning;
  };

  return (
    <>
      <input
        data-cy="serialnumber-submit"
        type="text"
        onChange={(e) => setSerialNumberSubmit(e)}
        onBlur={(e) => validateSerialNumber(itemNumberSubmit, e.target.value)}
        className={`form-control ${getInputClass()}`}
        onKeyUp={handleEnter}
        value={serialNumberSubmit}
        maxLength={30}
        placeholder={isMissingSerial ? "N/A" : ""}
        disabled={isMissingSerial}
        required={!isMissingSerial}
      />

      <div className="invalid-feedback">{getErrorMessage()}</div>
    </>
  );
};

SerialNumberInput.propTypes = {
  serialNumberSubmit: PropTypes.string,
  serialNumberWarning: PropTypes.bool,
  serialNumberErrors: PropTypes.bool,
  shown: PropTypes.bool,
  needsValidation: PropTypes.bool,
  localized: PropTypes.object,
  setSerialNumberSubmit: PropTypes.func,
  handleEnter: PropTypes.func,
  validateSerialNumber: PropTypes.func,
  itemNumberSubmit: PropTypes.string,
  illegitimateSerialNumber: PropTypes.bool,
  isMissingSerial: PropTypes.bool,
  isSDCItem: PropTypes.bool,
};

export default SerialNumberInput;
